import * as React from 'react';
import {useState} from 'react';
import {setGrayScale, setPersonImage, setStatusColor} from "../../service/DashboardService.js";
import {styled} from "@mui/system";
import Avatar from "@mui/material/Avatar";
import themeContext from "../ThemeContext.js";
import CardContent from "@mui/material/CardContent";
import {Row} from "react-bootstrap";
import {upperCaseFirst} from "upper-case-first";
import scrollbarUsersPlaceholder from "../../../images/user-placeholder.svg";
import {StyledBadge} from "../../styles/Styles.js";

const StyledAvatar = styled(Avatar)(({isselected}) => (
    isselected === 'true' ? {
        width: '66px !important',
        height: '66px !important',
        margin: '0 0 0 5px !important',
        boxShadow: `0px 2px 5px ${themeContext.color.boxShadow} !important`,
    } : {
        width: 56,
        height: 56,
        margin: '4px 7px 4px 7px !important',
    }
));

const userPlaceholder = (
    <div className={'d-flex flex-row'} style={{gap: '8px'}}>
        <img src={scrollbarUsersPlaceholder} alt={'usersPlaceholder-1'}/>
        <img src={scrollbarUsersPlaceholder} alt={'usersPlaceholder-2'}/>
        <img src={scrollbarUsersPlaceholder} alt={'usersPlaceholder-3'}/>
    </div>
)

const AvatarGroup = React.memo(function AvatarGroup({people, isLoading, selected, onChange, showBadge = false}) {
    const [selectedAvatar, setSelectedAvatar] = useState(selected || false);

    const handleAvatar = (e, item) => {
        e.preventDefault();
        if (selectedAvatar === item) {
            setSelectedAvatar(false);
            onChange(false, e);
            return;
        }
        setSelectedAvatar(item);
        onChange(item, e);
    };

    return (
        isLoading ? userPlaceholder : (
            people.map((person) => (
                <div className="card card-avatar" key={person.id}
                     style={{'backgroundColor': themeContext.color.neutral10}}>
                    <CardContent className="card-avatar-content"
                                 style={{'backgroundColor': themeContext.color.neutral10}}>
                        <Row style={{'width': '50px'}}>
                            {showBadge ?
                                <StyledBadge
                                    badgeContent={person.payableNotificationsNr ? person.payableNotificationsNr : '0'}
                                    overlap="circular"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}>
                                    <StyledAvatar alt="my-avatar" key={person.id}
                                                  isselected={(selectedAvatar === person.id).toString()}
                                                  src={person ? setPersonImage(person.gender, person.image) : null}
                                                  style={{
                                                      filter: `${setGrayScale(person.status)}`,
                                                      border: `${themeContext.spacing.borders.border3} ${setStatusColor(person.status)}`
                                                  }}
                                                  onClick={(e) => handleAvatar(e, person.id)}/>
                                </StyledBadge>
                                :
                                <StyledAvatar alt="my-avatar" key={person.id}
                                              isselected={(selectedAvatar === person.id).toString()}
                                              src={person ? setPersonImage(person.gender, person.image) : null}
                                              style={{
                                                  filter: `${setGrayScale(person.status)}`,
                                                  border: `${themeContext.spacing.borders.border3} ${setStatusColor(person.status)}`
                                              }}
                                              onClick={(e) => handleAvatar(e, person.id)}/>
                            }
                        </Row>
                        <Row
                            style={selectedAvatar === person.id ? {'width': '73px'} : {'width': '67px'}}>
                            <h6 className={selectedAvatar === person.id ? "avatar-text-big text-uppercase" : "avatar-text text-uppercase"}
                                style={selectedAvatar === person.id ? {color: `${setStatusColor(person.status)}`} : {}}>
                                {((person.first_name === null || person.first_name === "") && (person.last_name === null || person.last_name === "")) ? upperCaseFirst(`${person.name}`)
                                    : <span><span
                                        className="ellipsis-1">{upperCaseFirst(`${person.first_name}`)} </span><span
                                        className="ellipsis-1">{upperCaseFirst(`${person.last_name}`)}</span></span>
                                }
                            </h6>
                        </Row>
                    </CardContent>
                </div>
            ))
        )
    );
})

export default AvatarGroup;
